import { ROUTES_CONFIG } from '@/config/routes.config'
import { useTRPC } from '@/trpc'
import { useQuery } from '@tanstack/react-query'
import { useTypedParams } from 'react-router-typesafe-routes'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/animated-tabs';
import { useState } from 'react';
import Overview from './(components)/overview';
import PlayersOffered from './(components)/players-offered';
import { Link } from 'react-router-dom';
import * as Icon from 'lucide-react'

const ContactDetailPage = () => {
    const { contact_id } = useTypedParams(ROUTES_CONFIG.APP.CONTACTS.DETAIL)
    const { trpc } = useTRPC();

    const [tab, setTab] = useState<string>('overview');

    const { data:contact } = useQuery({
        queryKey: ['contact', contact_id],
        queryFn: async () => {
            const contact = await trpc.contacts.search.query({
                id: contact_id
            })
            return contact[0];
        },
    })

    return (
        <div className='p-4 flex flex-col gap-4 justify-between h-full'>
            <header className='flex flex-col gap-2'>
                <Link to={ROUTES_CONFIG.APP.CONTACTS.$buildPath({})} className='text-sm font-medium text-foreground/50 hover:text-foreground hover:underline w-fit flex items-center gap-2'>
                    <Icon.ArrowLeft className="w-4 h-4" />
                    Terug
                </Link>
                <p className='text-3xl font-semibold'>{contact?.contact_name}</p>
            </header>

            <main className='bg-card h-full overflow-auto rounded-lg'>
                <div className='flex flex-col justify-between h-full'>
                    <div className='border-b p-2'>
                        <Tabs value={tab} onValueChange={setTab}>
                            <TabsList>
                                <TabsTrigger value="overview">Overzicht</TabsTrigger>
                                <TabsTrigger value="players-offered">Aangeboden spelers</TabsTrigger>
                            </TabsList>
                        </Tabs>
                    </div>
                    <div className='h-full overflow-auto p-4'>
                        <div className='flex flex-col h-full'>
                            {tab === "overview" && <Overview contact_id={contact_id} />}
                            {tab === "players-offered" && <PlayersOffered contact_id={contact_id} />}
                        </div>
                    </div>
                </div>
            </main>
                        
        </div>
    )
}

export default ContactDetailPage